import { Link } from "react-router-dom";
import { Heart, ArrowRight, Sparkles, CalendarHeart, Users } from "lucide-react";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#FDFBF7] text-[#1C1917]">
      <div className="grain absolute inset-0 pointer-events-none" />
      {/* Nav */}
      <header className="relative z-10 mx-auto flex max-w-6xl items-center justify-between px-6 py-6">
        <div className="flex items-center gap-2">
          <Heart className="h-5 w-5 text-[#1A362D]" fill="#1A362D" />
          <span className="font-serif text-2xl font-semibold tracking-tight">Events</span>
        </div>
        <Link
          to="/admin/login"
          data-testid="landing-admin-login-link"
          className="rounded-full border border-[#1A362D]/20 px-5 py-2 text-sm font-medium transition-colors hover:bg-[#1A362D] hover:text-white"
        >
          Host Login
        </Link>
      </header>

      {/* Hero */}
      <section className="relative z-10 mx-auto grid max-w-6xl items-center gap-12 px-6 pt-12 pb-24 md:grid-cols-2 md:pt-24">
        <div>
          <p className="overline text-[#1A362D]/70 mb-6">The Art of the Invitation</p>
          <h1 className="font-serif text-5xl font-light leading-none tracking-tight md:text-7xl">
            Invitations worthy of the moment.
          </h1>
          <p className="mt-8 max-w-md text-lg leading-relaxed text-[#57534E]">
            Create breathtaking personalised wedding invitations, manage every guest, and track RSVPs — all shared with a single WhatsApp link.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/admin/login"
              data-testid="landing-get-started"
              className="group inline-flex items-center gap-2 rounded-full bg-[#1A362D] px-7 py-3.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
            >
              Enter the Host Console
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-[2rem] shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1698802060978-84008afaeb72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwY291cGxlJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1OTU3MzYxfDA&ixlib=rb-4.1.0&q=85"
              alt="Elegant couple"
              className="h-[520px] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 rounded-2xl border border-white/50 bg-white/80 px-6 py-4 shadow-xl backdrop-blur-xl">
            <p className="font-serif text-3xl">Aarav & Meera</p>
            <p className="text-xs text-[#57534E]">12 December 2026 · New Delhi</p>
          </div>
        </div>
      </section>

      {/* Feature strip */}
      <section className="relative z-10 mx-auto max-w-6xl border-t border-[#1C1917]/10 px-6 py-16">
        <div className="grid gap-10 md:grid-cols-3">
          {[
            { icon: Sparkles, title: "Premium Microsites", desc: "A cinematic invitation website for every guest, mobile-first and elegant." },
            { icon: Users, title: "Guest Management", desc: "Import from Excel, track every family, and share personalised links instantly." },
            { icon: CalendarHeart, title: "Live RSVP Tracking", desc: "Real-time dashboard with confirmations, headcounts and attendance charts." },
          ].map((f) => (
            <div key={f.title}>
              <f.icon className="mb-4 h-6 w-6 text-[#1A362D]" />
              <h3 className="font-serif text-2xl">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#57534E]">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
